import { coreTranslations } from 'translations';

const configureMenuItems = _rootMenu;

function _rootMenu() {
    return {
        i18n: coreTranslations.ng_core_configure,
        linkTitle: 'Configure',
        icon: 'onsolve-configure-icon',
        routeTo: '/configure',
        isRenderable: true
    };
}

export default configureMenuItems;
